export default __webpack_public_path__ + "static/cloud2-7cc884f2f8a914c090c3739513672c59.png";